
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type KeywordsSearchPageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function KeywordsSearchPageRT(): TemplateResult<KeywordsSearchPageRTRootProps> {
    return _createElement('div', { 'className': 'clear-self cm_SearchPage cm_SearchPage_keywords' }, [this.SearchBox_keywords(function () {
            function onSubmit1(event) {
                window.Convermax.onKeywordsSearchSubmit(event, this);
            }
            function repeatI2(i, iIndex) {
                return _createElement('input', {
                    'key': i,
                    'type': 'text',
                    'className': 'cm_keywords_input form-control',
                    'autoComplete': 'off'
                });
            }
            function onClick3() {
                this.setQuery('');
            }
            return _createElement('div', { 'className': 'cm_SearchBox_keywords' }, _createElement('div', { 'className': 'cm_search-box-root__keywords cm_keywords' }, _createElement('form', {
                'className': 'cm_keywords_form',
                'onSubmit': onSubmit1.bind(this)
            }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_keywords_inputs' },
                _map([
                    1,
                    2,
                    3,
                    4,
                    5
                ], repeatI2.bind(this))
            ]), _createElement('div', { 'className': 'cm_keywords_button-container' }, _createElement('button', {
                'type': 'submit',
                'className': 'btn btn-primary cm_keywords_button cm_keywords_button__submit'
            }, '\n        Submit\n      '), _createElement('button', {
                'type': 'reset',
                'onClick': onClick3.bind(this),
                'className': 'btn btn-secondary cm_keywords_button cm_keywords_button__clear'
            }, '\n        Clear\n      ')), _createElement('div', { 'className': 'cm_hide' }, _createElement('div', { 'className': 'cm_dropdown' })))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.responseQuery ? _createElement('div', {
        'className': 'cm_main-content',
        'key': '1878'
    }, _createElement('div', { 'id': 'itemsBlock' }, [this.message(function () {
            return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                    'href': 'mailto:support@convermax.com',
                    'className': 'cm_message-link'
                }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                    'className': 'cm_message__incompatible',
                    'key': '8800'
                }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                    'className': 'cm_message__nothing-for-vehicle',
                    'key': '10670'
                }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'href': this.searchByVehicleUrl
                }, _translate(`message_view_compatible_products`)))] : null, this.template === 'badRequest' ? _createElement('div', {
                'className': 'cmTemplate_badRequest',
                'key': '1390'
            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.startOver
            }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '16790' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '17660' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '18490' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '16424' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                'className': 'cmTemplate_corrected',
                'key': '2012'
            }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                originalQuery: this.
                originalQuery, 
                query
            : this.
                query
             }))) : null, this.template === 'networkError' ? _createElement('div', {
                'className': 'cmTemplate_networkError',
                'key': '2179'
            }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '23610' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '24480' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '25310' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '23244' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.template === 'nothing' && !this.hasMessage('KeywordsNotFound') ? [_createElement('div', { 'key': '26940' }, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                    'tabIndex': '0',
                    'className': 'cm_message-link',
                    'onClick': this.startOver,
                    'key': '2856'
                }, _translate(`message_reset_search`)) : null)] : null, this.template === 'partial' ? _createElement('div', {
                'className': 'cmTemplate_partial',
                'key': '3058'
            }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                'className': 'cmTemplate_timeout',
                'key': '3212'
            }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                'className': 'cmTemplate_unknown',
                'key': '3452'
            }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                'tabIndex': '0',
                'className': 'cm_message-link',
                'onClick': this.retry
            }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                '\n    (',
                this.error.status ? [
                    _createElement('b', { 'key': '37310' }, 'status:'),
                    ' ',
                    this.error.status,
                    ', '
                ] : null,
                this.error.userId ? [
                    _createElement('b', { 'key': '38180' }, 'id:'),
                    ' ',
                    this.error.userId,
                    ', '
                ] : null,
                this.error.timestamp ? [
                    _createElement('b', { 'key': '39010' }, 'timestamp:'),
                    ' ',
                    this.error.timestamp,
                    ', '
                ] : null,
                _createElement('b', { 'key': '36944' }, 'instance:'),
                ' ',
                this.error.instance,
                ')'
            ] : null)) : null, this.hasMessage('LicensePlateNotFound') ? [_createElement('div', { 'key': '40650' }, 'Failed to find your license plate number.')] : null, this.hasMessage('KeywordsNotFound') ? [_createElement('div', { 'key': '42020' }, 'No results found for your keywords.')] : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.customMessage(function () {
            return _createElement('div', { 'className': 'cm_message cm_customMessage' }, []);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.FilterChips(function () {
            return _createElement('div', { 'className': 'cm_filterChips cm_filterChips__search-header cm_FilterChips' }, [this.filterChips(function () {
                    function repeatChips1(chips, chipsIndex) {
                        return [chips(function () {
                                function repeatI1_reviewChip(i, iIndex) {
                                    return _createElement('span', {
                                        'key': `${ this.field }|${ i }`,
                                        'className': 'cm_star cm_star__' + (!(this.value - i) || this.value - i < 0.25 ? 'empty' : this.value - i < 0.75 ? 'half' : 'full')
                                    });
                                }
                                return this.template === 'chip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_chip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name === 'filterQuery' ? _translate(`filter_search_box_current_search`) : this.name === 'query' ? _translate(`current_query_label`) : this.name, ':'), '\n  ', this.value, '\n'), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '3500'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'reviewChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_reviewChip' }, _createElement.apply(this, [
                                    'a',
                                    {
                                        'className': 'facetentrykey',
                                        'tabIndex': '0',
                                        'role': 'listitem'
                                    },
                                    _createElement('span', { 'className': 'cm_chip-name' }, this.name, ': '),
                                    _map([
                                        0,
                                        1,
                                        2,
                                        3,
                                        4
                                    ], repeatI1_reviewChip.bind(this)),
                                    this.value !== '5' ? _createElement('span', { 'key': '391' }, ' and up') : null
                                ]), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '4900'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : this.template === 'rangeChip' ? _createElement('div', { 'className': 'facetdiv cmTemplate_rangeChip' }, _createElement('a', {
                                    'className': 'facetentrykey',
                                    'tabIndex': '0',
                                    'role': 'listitem'
                                }, _createElement('span', { 'className': 'cm_chip-name' }, this.name, ':'), this.finite ? [
                                    this.selectedRange[0],
                                    ' ',
                                    _translate(`ranged_facet_range_delimiter`),
                                    ' ',
                                    this.selectedRange[1]
                                ] : null, this.toPosInf ? [
                                    this.selectedRange[0],
                                    ' ',
                                    _translate(`ranged_facet_more`)
                                ] : null, this.toNegInf ? [
                                    this.selectedRange[1],
                                    ' ',
                                    _translate(`ranged_facet_less`)
                                ] : null), _createElement('div', { 'className': 'facetentryval' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-times',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '0 0 22 22',
                                        'key': '5360'
                                    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                            }, { count: undefined })];
                    }
                    return _createElement('div', { 'className': 'cm_filterChips' }, _createElement('div', { 'className': 'facetholder' }, _createElement('div', {
                        'className': 'facettitle',
                        'tabIndex': '0'
                    }, _translate(`selected_facets_label`)), _createElement('div', { 'className': 'facetbody' }, _createElement('div', {
                        'className': 'facetdiv cm_filter-chips_button',
                        'data-cm-role': 'start-over'
                    }, _createElement('a', {
                        'className': 'facetentrykey',
                        'tabIndex': '0',
                        'role': 'listitem'
                    }, 'Clear All')), _createElement.apply(this, [
                        'div',
                        {
                            'role': 'list',
                            'className': 'cmRepeater_chips'
                        },
                        _map(this.chips, repeatChips1.bind(this))
                    ]))));
                }, {
                    widgetName: 'filter-chips',
                    items: undefined
                })]);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchHeader(function () {
            return _createElement('div', { 'className': 'cm_SearchHeader' }, [this.facetDialogButton(function () {
                    return _createElement('div', { 'className': 'cm_facetDialogButton' }, [this.dialogButton(function () {
                            return _createElement('div', { 'className': 'btn btn-primary cm_dialogButton' }, '\n  ', _translate(`facet_dialog_open_button`), ' \n    ', this.withSelection ? [_createElement('svg', {
                                    'className': 'cm_icon cm_filter-icon',
                                    'viewBox': '-5 0 394 394.00003',
                                    'key': '950'
                                }, _createElement('path', { 'd': 'm367.82 0h-351.26c-6.1992-0.011719-11.879 3.4492-14.711 8.9609-2.8711 5.5859-2.3672 12.312 1.3008 17.414l128.69 181.29c0.042968 0.0625 0.089843 0.12109 0.13281 0.18359 4.6758 6.3125 7.207 13.961 7.2188 21.816v147.8c-0.027344 4.375 1.6914 8.582 4.7734 11.688 3.0859 3.1016 7.2812 4.8516 11.656 4.8516 2.2227-0.003906 4.4258-0.44531 6.4805-1.3008l72.312-27.57c6.4766-1.9805 10.777-8.0938 10.777-15.453v-120.02c0.011719-7.8555 2.543-15.504 7.2148-21.816 0.042968-0.0625 0.089844-0.12109 0.13281-0.18359l128.69-181.29c3.668-5.0977 4.1719-11.82 1.3008-17.406-2.8281-5.5156-8.5117-8.9766-14.707-8.9648z' }))] : null, !this.withSelection ? [_createElement('svg', {
                                    'className': 'cm_icon cm_filter-icon',
                                    'viewBox': '0 0 247.46 247.46',
                                    'key': '8360'
                                }, _createElement('path', { 'd': 'm246.74 13.984c-1.238-2.626-3.881-4.301-6.784-4.301h-232.46c-2.903 0-5.545 1.675-6.784 4.301-1.238 2.626-0.85 5.73 0.997 7.97l89.361 108.38v99.94c0 2.595 1.341 5.005 3.545 6.373 1.208 0.749 2.579 1.127 3.955 1.127 1.137 0 2.278-0.259 3.33-0.78l50.208-24.885c2.551-1.264 4.165-3.863 4.169-6.71l0.098-75.062 89.366-108.39c1.848-2.239 2.237-5.344 0.999-7.969zm-103.65 108.89c-1.105 1.34-1.711 3.023-1.713 4.761l-0.096 73.103-35.213 17.453v-90.546c0-1.741-0.605-3.428-1.713-4.771l-80.958-98.191h200.65l-80.958 98.191z' }))] : null);
                        }, {
                            widgetName: 'undefined',
                            items: undefined
                        })]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('div', {
                'className': 'cm_total-hits',
                'role': 'status'
            }, _createElement('div', {}, '\n  Showing ', _createElement('span', { 'className': 'cm_total-hits_count' }, this.pageFrom, ' - ', this.pageTo), ' of\n  ', _createElement('span', { 'className': 'cm_total-hits_count' }, this.totalHits), ' ', _translate(`total_products_count_title`), '\n')), _createElement('div', { 'className': 'cm_sort sort-by cm_mobile-hide' }, _createElement('span', { 'className': 'sort-label' }, _translate(`sort_select_label`)), '\n  ', this.sortSelect, '\n'), _createElement('div', {
                'className': 'cm_sort-dialog-btn btn btn-dark-outline btn-outline-dark cm_desktop-hide',
                'onClick': () => window.Convermax.openDialog('SortDialog')
            }, '\n  SORT\n'));
        }, {
            widgetName: 'search-header',
            items: undefined
        })], [this.SearchHeader(function () {
            return _createElement('div', { 'className': 'cm_SearchHeader__mobile cm_SearchHeader' }, _createElement('div', {
                'className': 'cm_total-hits cm_total-hits__mobile cm_desktop-hide',
                'role': 'status'
            }, _createElement('div', {}, '\n  Showing ', _createElement('span', { 'className': 'cm_total-hits_count' }, this.pageFrom, ' - ', this.pageTo), ' of\n  ', _createElement('span', { 'className': 'cm_total-hits_count' }, this.totalHits), ' ', _translate(`total_products_count_title`), '\n')));
        }, {
            widgetName: 'undefined',
            items: undefined
        })], [this.SearchResult(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        function onClick1() {
                            window.Convermax.openDialog('DifferentialVehicleDialog', { withCurrentVehicle: true });
                        }
                        function repeatBadge2(badge, badgeIndex) {
                            return _createElement('span', {
                                'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                                'key': badge
                            }, '\n      ', badge, '\n    ');
                        }
                        function mergeProps(inline, external) {
                            var res = Object.assign({}, inline, external);
                            if (inline.hasOwnProperty('style')) {
                                res.style = _.defaults(res.style, inline.style);
                            }
                            if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                res.className = external.className + ' ' + inline.className;
                            }
                            return res;
                        }
                        return _createElement('div', { 'className': 'card-container d-flex align-items-stretch justify-content-around mb-8 col-12' + (this.show_differential_banner ? '' : ' col-lg-4 col-md-4 col-sm-6 col-xs-6') }, this.show_differential_banner ? [_createElement('div', {
                                'className': 'bg-white border border-3 border-yellow p-4 py-xxl-6 ps-xxl-3 pe-xxl-6 rounded-1 w-100',
                                'key': '2030'
                            }, _createElement('div', { 'className': 'row align-items-center d-flex flex-column flex-xxl-row flex-wrap justify-content-between' }, _createElement('div', { 'className': 'align-items-xxl-center col-xxl-auto d-flex flex-column flex-xxl-row gap-3 gap-xxl-6 justify-content-xxl-center' }, _createElement('svg', {
                                'width': '32',
                                'height': '32',
                                'viewBox': '0 0 24 24',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg'
                            }, _createElement('path', {
                                'd': 'M13.3836 3.09207L22.585 19.2838C22.7253 19.5307 22.7992 19.8107 22.7992 20.0958C22.7992 20.3809 22.7254 20.661 22.5851 20.9079C22.4448 21.1548 22.243 21.3598 22 21.5024C21.7569 21.6449 21.4813 21.72 21.2007 21.72H2.79776C2.51716 21.72 2.24149 21.6449 1.99848 21.5024C1.75547 21.3598 1.55368 21.1548 1.41338 20.9079C1.27308 20.661 1.19922 20.3809 1.19922 20.0958C1.19922 19.8107 1.27309 19.5307 1.41339 19.2838L10.6148 3.09207C11.2298 2.00931 12.7676 2.00931 13.3836 3.09207Z',
                                'fill': '#231F20'
                            }), _createElement('path', {
                                'd': 'M13.5382 2.2581L23.762 19.9657C23.9179 20.2357 24 20.542 24 20.8538C24 21.1656 23.9179 21.4719 23.762 21.7419C23.6062 22.0119 23.3819 22.2361 23.1119 22.392C22.8419 22.5479 22.5356 22.63 22.2238 22.63H1.77616C1.46437 22.63 1.15808 22.5479 0.888073 22.392C0.618062 22.2361 0.393844 22.0119 0.237955 21.7419C0.0820658 21.4719 -1.98017e-06 21.1656 0 20.8538C1.98024e-06 20.542 0.0820737 20.2357 0.237966 19.9657L10.4618 2.2581C11.1451 1.07396 12.8538 1.07396 13.5382 2.2581ZM12 16.2925C11.6859 16.2925 11.3848 16.4172 11.1627 16.6393C10.9406 16.8614 10.8159 17.1626 10.8159 17.4766C10.8159 17.7907 10.9406 18.0919 11.1627 18.3139C11.3848 18.536 11.6859 18.6608 12 18.6608C12.3141 18.6608 12.6152 18.536 12.8373 18.3139C13.0594 18.0919 13.1841 17.7907 13.1841 17.4766C13.1841 17.1626 13.0594 16.8614 12.8373 16.6393C12.6152 16.4172 12.3141 16.2925 12 16.2925ZM12 8.00353C11.71 8.00357 11.43 8.11005 11.2133 8.30278C10.9966 8.49551 10.8581 8.76108 10.8242 9.04912L10.8159 9.18767V13.9242C10.8162 14.226 10.9318 14.5163 11.139 14.7358C11.3461 14.9552 11.6293 15.0873 11.9306 15.105C12.2319 15.1227 12.5286 15.0247 12.76 14.831C12.9915 14.6372 13.1402 14.3625 13.1758 14.0628L13.1841 13.9242V9.18767C13.1841 8.87362 13.0594 8.57243 12.8373 8.35036C12.6152 8.12829 12.3141 8.00353 12 8.00353Z',
                                'fill': '#FEC600'
                            })), _createElement('div', {}, _createElement('h2', { 'className': 'h4 mb-xxl-2 mb-2' }, 'Make Sure You\'re Getting the Right parts.'), _createElement('p', { 'className': 'fs-md fw-normal mb-xxl-1 mb-2' }, '\n          Choose your differential to find the correct parts for your\n        '), _createElement('h3', { 'className': 'h5 m-0' }, '\n          ', window.Convermax.getVehicleLabelWithoutDifferential(window.Convermax.getVehicle()), '\n        '))), _createElement('div', { 'className': 'align-items-center col-xxl-auto d-flex flex-column flex-xxl-row flex-wrap justify-content-xxl-end mx-0' }, _createElement('div', { 'className': 'mt-3 mt-xxl-0 w-100' }, _createElement('button', {
                                'className': 'border border-gray-80 btn btn-primary w-100',
                                'onClick': onClick1.bind(this)
                            }, '\n          add differential\n        ')))))] : null, !this.show_differential_banner ? [_createElement('a', {
                                'href': this.url,
                                'className': 'card card-product text-start',
                                'key': '33810'
                            }, _createElement.apply(this, [
                                'span',
                                { 'className': 'badges' },
                                this.on_sale ? _createElement('span', {
                                    'className': 'badge badge-sale',
                                    'key': '3519'
                                }, 'On sale') : null,
                                this.out_of_stock ? _createElement('span', {
                                    'className': 'badge badge-sold-out',
                                    'key': '3590'
                                }, _translate(`product_out_of_stock`)) : null,
                                this._badges ? _map(this._badges, repeatBadge2.bind(this)) : null
                            ]), _createElement('div', { 'className': 'product--media product-images-wrapper mb-2' }, _createElement('div', {
                                'className': 'product--media square',
                                'data-mediaid': this.id
                            }, _createElement('a', { 'className': 'd-block product-link position-relative w-100' }, _createElement('img', {
                                'src': this.imageOrDefault(this.resizeImage(this.image)),
                                'alt': this.removeHTML(this.title),
                                'onError': this.onImageError
                            }), this.image2 ? _createElement('img', {
                                'src': this.resizeImage(this.image2),
                                'alt': this.removeHTML(this.title),
                                'onError': e => this.onImageError(e, 'image2'),
                                'key': '4206'
                            }) : null))), _createElement('div', { 'className': 'text-block text-md-start text-start fs-xs mb-md-0 mb-0' }, _createElement('p', { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })), _createElement('a', mergeProps({
                                'href': this.url,
                                'className': 'm-0 product_title text-black fs-base left text-start fw-bold text-math-auto'
                            }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('p', {
                                'className': 'product__sku ls-4 m-0 text-left',
                                'id': 'Sku-' + this.id,
                                'role': 'status'
                            }, _createElement('span', { 'className': 'visually-hidden' }, 'SKU:'), _createElement('span', { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } })), _createElement('div', { 'className': 'price-block mb-2 mt-lg-4 mt-2 text-left' }, _createElement('div', { 'className': 'align-items-center flex-wrap d-flex' }, _createElement('div', { 'className': 'align-items-center d-flex flex-wrap column-gap-2 me-2' }, _createElement('span', { 'className': 'price m-0 p-0 money' + (this.on_sale ? ' text-primary-300' : '') }, this.price_varies ? _createElement('span', { 'key': '5405' }, _translate(`price_from`), ' ') : null, '\n          ', this.formatPrice(this.min_price || this.price), '\n        '), this.on_sale ? _createElement('del', {
                                'className': 'price small m-0 p-0 text-gray-500 fw-semibold money d-inline-block',
                                'key': '5556'
                            }, '\n          ', this.formatPrice(this.compare_at_price), '\n        ') : null), this.on_sale ? _createElement('span', {
                                'className': 'badge',
                                'key': '5744'
                            }, '\n        ', this.calcDiscount(this.price, this.compare_at_price), '% off\n      ') : null), _createElement('form', {
                                'method': 'post',
                                'action': '/cart/add',
                                'id': 'product-form-installment',
                                'acceptCharset': 'UTF-8',
                                'className': 'installment caption-large',
                                'encType': 'multipart/form-data',
                                'data-productid': this.id
                            }, _createElement('input', {
                                'type': 'hidden',
                                'name': 'form_type',
                                'value': 'product'
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'utf8',
                                'value': '\u2713'
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'id',
                                'data-productid': this.id,
                                'value': this.variant_ids
                            }), _createElement('input', {
                                'type': 'hidden',
                                'name': 'product-id',
                                'value': this.id
                            }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                                'type': 'hidden',
                                'name': 'properties[Fitment]',
                                'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                                'key': '6350'
                            }) : null)), this.price ? _createElement('p', {
                                'className': 'affirm-as-low-as',
                                'data-amount': this.price * 100,
                                'data-affirm-type': 'logo',
                                'data-affirm-color': 'blue',
                                'key': '6574'
                            }) : null)] : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_SearchResult' }, _createElement.apply(this, [
                'div',
                { 'className': 'row' + (this.view ? ` ${ this.view }` : '') + ' cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.message(function () {
                    return _createElement('div', { 'className': 'cm_message' }, this.demoPlanActive ? [_createElement('div', { 'key': '240' }, '\n  Your store is currently running Convermax Search on a demo plan. The only limitation is that some product\n  images are replaced with a picture of a goose. Please upgrade your plan to remove this restriction.\n')] : null, this.trialExpired ? [_createElement('div', { 'key': '3010' }, _createElement('h2', { 'className': 'cm_message-header' }, 'YMM Search trial period has expired.'), '\n  Product information, including pricing and fitments, is outdated. This store runs on a limited trial version\n  of Convermax Year Make Model fitment search. Please contact\n  ', _createElement('a', {
                            'href': 'mailto:support@convermax.com',
                            'className': 'cm_message-link'
                        }, 'support@convermax.com'), ' to complete setup\n  or cancel the integration.\n')] : null, this.aggressiveWheels ? [_createElement('div', { 'key': '7510' }, _translate(`message_aggressive_wheels`, {  vehicleString : this. vehicleString  }))] : null, this.incompatibleParts ? [_createElement('div', {
                            'className': 'cm_message__incompatible',
                            'key': '8800'
                        }, _createElement('div', {}, _translate(`message_incompatible_text_results`, {  vehicleString : this. vehicleString  })))] : null, this.nonVehicleSpecificResults ? [_createElement('div', {
                            'className': 'cm_message__nothing-for-vehicle',
                            'key': '10670'
                        }, '\n  ', _translate(`message_non_vehicle_specific_results`, {  vehicleString : this. vehicleString  }), '\n  ', _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'href': this.searchByVehicleUrl
                        }, _translate(`message_view_compatible_products`)))] : null, this.template === 'badRequest' ? _createElement('div', {
                        'className': 'cmTemplate_badRequest',
                        'key': '1390'
                    }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.startOver
                    }, _translate(`message_reset_search`)), _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '16790' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '17660' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '18490' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '16424' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.template === 'corrected' ? _createElement('div', {
                        'className': 'cmTemplate_corrected',
                        'key': '2012'
                    }, _createElement('div', {}, _translate(`message_query_corrected`, { 
                        originalQuery: this.
                        originalQuery, 
                        query
                    : this.
                        query
                     }))) : null, this.template === 'networkError' ? _createElement('div', {
                        'className': 'cmTemplate_networkError',
                        'key': '2179'
                    }, _createElement('div', {}, '\n  ', _translate(`message_network_error`), '\n  ', _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '23610' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '24480' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '25310' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '23244' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.template === 'nothing' && !this.hasMessage('KeywordsNotFound') ? [_createElement('div', { 'key': '26940' }, '\n  ', _translate(`message_no_results`), '\n  ', this.query || this.isFacetsSelected || this.isSearchedByVehicle ? _createElement('a', {
                            'tabIndex': '0',
                            'className': 'cm_message-link',
                            'onClick': this.startOver,
                            'key': '2856'
                        }, _translate(`message_reset_search`)) : null)] : null, this.template === 'partial' ? _createElement('div', {
                        'className': 'cmTemplate_partial',
                        'key': '3058'
                    }, _createElement('div', {}, _translate(`message_query_partial`, {  originalQuery : this. originalQuery  }))) : null, this.template === 'timeout' ? _createElement('div', {
                        'className': 'cmTemplate_timeout',
                        'key': '3212'
                    }, _createElement('div', {}, '\n  ', _translate(`message_timeout`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, _translate(`message_retry_search`)))) : null, this.template === 'unknown' ? _createElement('div', {
                        'className': 'cmTemplate_unknown',
                        'key': '3452'
                    }, _createElement('div', {}, '\n  ', _translate(`message_search_failed`), '\n  ', _createElement('a', {
                        'tabIndex': '0',
                        'className': 'cm_message-link',
                        'onClick': this.retry
                    }, _translate(`message_retry_search`)), _createElement('br', {}), this.error ? [
                        '\n    (',
                        this.error.status ? [
                            _createElement('b', { 'key': '37310' }, 'status:'),
                            ' ',
                            this.error.status,
                            ', '
                        ] : null,
                        this.error.userId ? [
                            _createElement('b', { 'key': '38180' }, 'id:'),
                            ' ',
                            this.error.userId,
                            ', '
                        ] : null,
                        this.error.timestamp ? [
                            _createElement('b', { 'key': '39010' }, 'timestamp:'),
                            ' ',
                            this.error.timestamp,
                            ', '
                        ] : null,
                        _createElement('b', { 'key': '36944' }, 'instance:'),
                        ' ',
                        this.error.instance,
                        ')'
                    ] : null)) : null, this.hasMessage('LicensePlateNotFound') ? [_createElement('div', { 'key': '40650' }, 'Failed to find your license plate number.')] : null, this.hasMessage('KeywordsNotFound') ? [_createElement('div', { 'key': '42020' }, 'No results found for your keywords.')] : null);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]);
        }, {
            widgetName: 'results',
            items: undefined
        })], [this.paginationMenu(function () {
            function repeatButtons1(buttons, buttonsIndex) {
                return [buttons(function () {
                        return this.template === 'prev' ? _createElement('div', { 'className': 'prev_page cmTemplate_prev' }, _createElement('a', {
                            'data-pagelinks': true,
                            'href': this.pageLink,
                            'title': '\xAB Previous',
                            'aria-label': '\xAB Previous',
                            'className': 'btn btn-outline-dark btn-sm'
                        }, [_createElement('svg', {
                                'viewBox': '0 0 40 40',
                                'fill': 'none',
                                'width': '10',
                                'height': '10',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '1880'
                            }, _createElement('path', {
                                'd': 'M30.6008 0.718571C31.7008 1.81857 31.7008 3.61857 30.6008 4.81857L15.4008 20.0186L30.6008 35.2186C31.5008 36.3186 31.5008 37.9186 30.6008 38.9186C29.6008 40.1186 27.8008 40.2186 26.6008 39.2186L9.40078 22.0186C8.30078 20.9186 8.30078 19.1186 9.40078 18.0186L26.6008 0.818573C27.1008 0.318573 27.9008 0.0185703 28.6008 0.0185702C29.4008 0.0185701 30.1008 0.318573 30.6008 0.818573L30.6008 0.718571Z',
                                'fill': 'currentColor'
                            }))], _createElement('span', { 'className': 'd-md-block d-none' }, 'Previous'))) : this.template === 'prevStub' ? _createElement('div', { 'className': 'prev_page cmTemplate_prevStub' }, _createElement('a', {
                            'data-pagelinks': true,
                            'title': '\xAB Previous',
                            'aria-label': '\xAB Previous',
                            'className': 'btn btn-outline-dark btn-sm disabled'
                        }, [_createElement('svg', {
                                'viewBox': '0 0 40 40',
                                'fill': 'none',
                                'width': '10',
                                'height': '10',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '1780'
                            }, _createElement('path', {
                                'd': 'M30.6008 0.718571C31.7008 1.81857 31.7008 3.61857 30.6008 4.81857L15.4008 20.0186L30.6008 35.2186C31.5008 36.3186 31.5008 37.9186 30.6008 38.9186C29.6008 40.1186 27.8008 40.2186 26.6008 39.2186L9.40078 22.0186C8.30078 20.9186 8.30078 19.1186 9.40078 18.0186L26.6008 0.818573C27.1008 0.318573 27.9008 0.0185703 28.6008 0.0185702C29.4008 0.0185701 30.1008 0.318573 30.6008 0.818573L30.6008 0.718571Z',
                                'fill': 'currentColor'
                            }))], _createElement('span', { 'className': 'd-md-block d-none' }, 'Previous'))) : this.template === 'page' ? _createElement('li', { 'className': 'page-item cmTemplate_page' }, !this.isActive ? _createElement('a', {
                            'className': 'page-link',
                            'href': this.pageLink,
                            'title': this.page,
                            'aria-label': this.page,
                            'key': '45'
                        }, _createElement('span', {}, this.page)) : null, this.isActive ? _createElement('a', {
                            'className': 'page-link active',
                            'key': '208'
                        }, _createElement('span', { 'className': 'active' }, this.page)) : null) : this.template === 'delimiter' ? _createElement('li', { 'className': 'page-item cmTemplate_delimiter' }, _createElement('span', { 'className': 'dots d-inline-flex align-items-end justify-content-center' }, _createElement('span', {}, '\u2026'))) : this.template === 'next' ? _createElement('div', { 'className': 'next_page cmTemplate_next' }, _createElement('a', {
                            'data-pagelinks': true,
                            'href': this.pageLink,
                            'title': 'Next \xBB',
                            'aria-label': 'Next \xBB',
                            'className': 'btn btn-outline-dark btn-sm'
                        }, _createElement('span', { 'className': 'd-md-block d-none' }, 'Next'), [_createElement('svg', {
                                'viewBox': '0 0 40 40',
                                'fill': 'none',
                                'width': '10',
                                'height': '10',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '2320'
                            }, _createElement('path', {
                                'd': 'M30.6008 0.718571C31.7008 1.81857 31.7008 3.61857 30.6008 4.81857L15.4008 20.0186L30.6008 35.2186C31.5008 36.3186 31.5008 37.9186 30.6008 38.9186C29.6008 40.1186 27.8008 40.2186 26.6008 39.2186L9.40078 22.0186C8.30078 20.9186 8.30078 19.1186 9.40078 18.0186L26.6008 0.818573C27.1008 0.318573 27.9008 0.0185703 28.6008 0.0185702C29.4008 0.0185701 30.1008 0.318573 30.6008 0.818573L30.6008 0.718571Z',
                                'fill': 'currentColor'
                            }))])) : this.template === 'nextStub' ? _createElement('div', { 'className': 'next_page cmTemplate_nextStub' }, _createElement('a', {
                            'data-pagelinks': true,
                            'title': 'Next \xBB',
                            'aria-label': 'Next \xBB',
                            'className': 'btn btn-outline-dark btn-sm disabled'
                        }, _createElement('span', { 'className': 'd-md-block d-none' }, 'Next'), [_createElement('svg', {
                                'viewBox': '0 0 40 40',
                                'fill': 'none',
                                'width': '10',
                                'height': '10',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '2220'
                            }, _createElement('path', {
                                'd': 'M30.6008 0.718571C31.7008 1.81857 31.7008 3.61857 30.6008 4.81857L15.4008 20.0186L30.6008 35.2186C31.5008 36.3186 31.5008 37.9186 30.6008 38.9186C29.6008 40.1186 27.8008 40.2186 26.6008 39.2186L9.40078 22.0186C8.30078 20.9186 8.30078 19.1186 9.40078 18.0186L26.6008 0.818573C27.1008 0.318573 27.9008 0.0185703 28.6008 0.0185702C29.4008 0.0185701 30.1008 0.318573 30.6008 0.818573L30.6008 0.718571Z',
                                'fill': 'currentColor'
                            }))])) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'pagination row cm_paginationMenu' }, _createElement('div', { 'className': 'col-12 text-center mt-5' }, _createElement.apply(this, [
                'nav',
                { 'className': 'align-items-center d-flex flex-wrap cmRepeater_buttons' },
                _map(this.buttons, repeatButtons1.bind(this))
            ]), _createElement('div', { 'className': 'cm_hide' }, _createElement('div', { 'className': 'cm_toggle-dropdown' }), _createElement('div', { 'className': 'cm_paginationDropdown' }))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })])) : null);
}
        export const componentNames = ["cm:SearchBox_keywords","cm:message","cm:customMessage","cm:filterChips","cm:FilterChips","cm:dialogButton","cm:facetDialogButton","cm:SearchHeader","cm:SearchHeader","cm:message","cm:SearchResult","cm:paginationMenu"]